<template>

<div class="column">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.column {
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	width: calc(50% - 20px);
	margin-right: 40px;
}

.column:last-child {
	margin-right: 0;
}

.is-mobile .column {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 40px;
}

</style>